<template>
  <v-container fluid fill-height class="px-0">
    <v-row justify="end">
      <v-col align="end">
        <v-btn color="primary" @click="rerefeshContent()" fab>
          <v-icon> mdi-refresh </v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <span class="text-subtitle-1 font-weight-bold">Invenatrio</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-center">Litros en digestión</th>
                <th class="text-center">Semiterminado</th>
                <th class="text-center">Terminado</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-center">{{ summaryBio.process }}</td>
                <td class="text-center">{{ summaryBio.semifinished }}</td>
                <td class="text-center">{{ summaryBio.finished }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <span class="text-subtitle-1 font-weight-bold"
          >Tolvas en producción</span
        >
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          fixed-header
          height="auto"
          :headers="headers"
          :items="hoppers"
          :items-per-page="10"
          no-data-text="No hay tolvas"
          loading-text="Cargando tolvas..."
          :page.sync="page"
          hide-default-footer
          :loading="fetchingData"
          @click:row="rowSelect"
          :item-class="row_classes"
        >
          <template #[`item.isActive`]="{ item }">
            <span v-if="item.isActive" class="rounded-orange"> Activo </span>
            <span v-else class="rounded-green"> Disponible </span>
          </template>
          <template #[`item.lote`]="{ item }">
            <span v-if="item.lote">
              {{ item.lote.loteId }}
            </span>
            <span v-else> - </span>
          </template>
        </v-data-table>
        <v-pagination
          v-model="page"
          :length="numPages"
          total-visible="10"
          color="primary"
        ></v-pagination>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// vuex
import { mapActions, mapMutations } from "vuex";
export default {
  data: () => ({
    page: 1,
    numPages: 1,
    headers: [
      { text: "Tolva", align: "center", value: "name", sortable: false },
      {
        text: "Capacidad de licor",
        align: "center",
        value: "liquorVolume",
        sortable: false,
      },
      {
        text: "Capacidad total",
        align: "center",
        value: "capacity",
        sortable: false,
      },
      {
        text: "En digestion",
        align: "center",
        value: "availableVolume",
        sortable: false,
      },
      {
        text: "Disponibilidad",
        align: "center",
        value: "isActive",
        sortable: false,
      },
      {
        text: "Lote",
        align: "center",
        value: "lote",
        sortable: false,
      },
    ],
    hoppers: [],
    fetchingData: false,
    summaryBio: {
      process: 0,
      semifinished: 0,
      finished: 0,
    },
  }),

  async created() {
    await this.fetchData();
    await this.fetchSummary();
  },

  methods: {
    ...mapActions("lotes", ["getHoppers", "getSummaryBio"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    async fetchData() {
      try {
        this.fetchingData = true;
        let response = await this.getHoppers({
          page: this.page,
          flag: true,
        });
        if (response) {
          this.hoppers = response.hoppers;
          this.numPages = response.pages;
        } else {
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text: "Error al cargar tolvas",
            timeout: 3500,
          });
        }
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Error al cargar tolvas",
          timeout: 3500,
        });
      }
      this.fetchingData = false;
    },
    async fetchSummary() {
      try {
        let response = await this.getSummaryBio();
        if (response) {
          this.summaryBio = response.summary;
        } else {
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text: "Error al cargar tolvas",
            timeout: 3500,
          });
        }
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Error al cargar tolvas",
          timeout: 3500,
        });
      }
    },
    rowSelect(rowValue) {
      this.hoppers = this.hoppers.map((data) => {
        if (rowValue._id == data._id) {
          data.clicked = true;
        } else {
          data.clicked = false;
        }
        return data;
      });
    },
    row_classes(value) {
      if (value.clicked) {
        return "custom-highlight-row";
      }
    },
    async rerefeshContent() {
      await this.fetchData();
      await this.fetchSummary();
    },
  },
  watch: {
    async page() {
      await this.fetchData();
    },
  },
};
</script>

<style scoped>
.rounded-green {
  background-color: #ff8f1c;
  padding: 7px;
  color: white;
  border-radius: 7px;
}

.rounded-orange {
  background-color: #04c105;
  padding: 7px;
  color: white;
  border-radius: 7px;
}
</style>
